import React from "react";
import { InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';

const { Dragger } = Upload;

const DragAndDrop = ({uploadFileHandler, hintMessage, ...props}) => {
	
	const draggerProps = {
		name: 'file',
		multiple: true,
		customRequest({ file, onSuccess, onError }) {
			uploadFileHandler(file, onSuccess, onError);
		},
		onDrop(e) {
			console.log('Dropped files', e.dataTransfer.files);
		},
	};
	
	return (
		<Dragger {...props} {...draggerProps}>
			<p className="ant-upload-drag-icon">
				<InboxOutlined />
			</p>
			<p className="ant-upload-text">Click or drag file to this area to upload</p>
			<p className="ant-upload-hint">
			{hintMessage}
			</p>
		</Dragger>
			
    );
};


export default DragAndDrop;